<template>
    <div class="outer">
        <!-- eslint-disable max-len -->
        <div class="inner">
            <div class="photo" v-if="PhotoSource !== undefined">
                <b-img
                @click="modalShow()" :src='`images/${PhotoSource}`'
                alt='Photo'
                />
            </div>

            <div class="description">
                <h2>
                    {{username}}
                </h2>
                <p>
                    {{description}}
                </p>
                <a v-if='Website != "none"' :href="Website" target="_blank">{{ $translation.L("ENTER_WEBSITE") }}</a>
            </div>

            <div class="close" @click="$emit('closeModal')"/>
        </div>
    </div>
</template>

<script>
export default {
  name: 'modal',
  props: ['PhotoSource', 'description', 'username', 'Website'],
  methods: {
    resolveImgUrl(path) {
      const images = require.context('../../public/images/', false, /\.png$|\.jpg$/);
      try {
        return images(`./${path}`);
      } catch {
        return images('./blank-man.jpg');
      }
    },
  },
};
</script>

<style scoped>
    .outer {
        width: 100%;
        position: fixed;
        height: 110%;
        top: 0;
        left: 0;
        background-color: rgb(240, 240, 240);
        padding-top: -30px;
    }

    .inner {
        display: flex;
        height: 100%;
        padding: -10px 20px 0px;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .photo img {
        width: 90%;
        height: auto;
    }

    p {
        color: #333;
    }

    a {
        color: #444;
        margin-bottom: 10px;
    }

    .close {
        position: absolute;
        top: 35px;
        right: 35px;
        cursor: pointer;
        width: 20px;
        height:20px;
    }

    .close::before, .close::after {
        content: '';
        width:25px;
        height: 2px;
        background: black;
        display: block;
        position: absolute;
    }

    .close::after {
        transform: rotate(45deg);
    }

    .close::before {
        transform: rotate(-45deg);
    }

    h2 {
        color: #333;
        font-size: 10vw;
        border-bottom: 1px solid #333;
    }

    p {
        font-size: 5vw;
    }

    .description {
        margin-bottom: 10%;
    }

    @media only screen and (min-width: 1024px) {
        .outer {
            width: 70%;
            min-height: 30%;
            max-height: 80%;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            margin: auto;
            -webkit-box-shadow: 10px 10px 80px -10px rgb(0,0,0);
            -moz-box-shadow: 10px 10px 90px -10px rgb(0,0,0);
            box-shadow: 10px 10px 80px -10px rgb(0,0,0);
        }

        .inner {
            display: flex;
            height: 100%;
            padding: 50px;
            justify-content: center;
            align-items: center;
            flex-direction: row;
        }

        .description {
            max-width: 60%;
            display: block;
            margin: 0 auto;
        }

        p {
            font-size: 1.8vw;
        }

        h2 {
            font-size: 2.5vw;
        }

        .photo {
            width: 16vw;
            margin-left: 20px;
        }

        .photo img{
            width: 100%
        }

    }
</style>
